module.exports = __webpack_public_path__ + "static/media/iStock-500199833.61df405b.jpg";